import { registerPlugin } from '@wordpress/plugins';
import BlockbiteLogoIcon from 'blockbite-icons/dist/BlockbiteLogo';
import BlockbiteSiteSidebar from './sideBarSiteEditor.js';
import BlockbitePostSidebar from './sideBarPostEditor.js';

export const blockbiteRegisterSidebar = () => {
  const isSidebarRegistered = wp.plugins.getPlugin('plugin-sidebar-blockbite');
  if (!isSidebarRegistered) {
    if (blockbite.getEditorType() === 'edit-post') {
      registerPlugin('plugin-sidebar-blockbite', {
        render: BlockbitePostSidebar,
        icon: <BlockbiteLogoIcon width="22" height="22" />,
      });
    } else if (blockbite.getEditorType() === 'edit-site') {
      registerPlugin('plugin-sidebar-blockbite', {
        render: BlockbiteSiteSidebar,
        icon: <BlockbiteLogoIcon width="22" height="22" />,
      });
    }
  }
};
